import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import backgroundImg from '../../assets/screens/screen-confirmation-seasonal-ticket.png';
import CardReaderScreen from '../../molecules/CardReaderScreen';
import { TICKET_TYPE_SEASONAL_TICKET } from '../../constants';
import ConfirmationScreenContent from '../../molecules/ConfirmationScreenContent/ConfirmationScreenContent';
import { getDateString15DaysFromNow } from '../../time';

const getTicketZones = (currentZone) => {
  switch (currentZone) {
    case 'C':
      return 'BC';
    case 'D':
      return 'BCD';
    case 'A':
    case 'B':
    default:
      return 'AB';
  }
};

class SeasonalTicketConfirmationRC extends PureComponent {
  render() {
    const { currentZone, remainingFunds } = this.props;
    const seasonalTicket = {
      zones: getTicketZones(currentZone),
      validityEndsAtString: getDateString15DaysFromNow(),
    };
    return (
      <CardReaderScreen backgroundImage={backgroundImg}>
        <ConfirmationScreenContent
          currentZone={currentZone}
          ticketType={TICKET_TYPE_SEASONAL_TICKET}
          seasonalTicket={seasonalTicket}
          remainingFunds={remainingFunds}
        />
      </CardReaderScreen>
    );
  }
}

SeasonalTicketConfirmationRC.propTypes = {
  currentZone: PropTypes.string.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  remainingFunds: cardReader.remainingFunds,
});

export default connect(mapStateToProps)(SeasonalTicketConfirmationRC);
